import { buildOrganizationApiUrl } from "../../../configuration";

export const userLogoUrl = (userId: string) => {
  return buildOrganizationApiUrl(`/organizations/${userId}/logo`);
};
